<app-header></app-header>
<app-nav-menu></app-nav-menu>
<main id="main" class="main">

  <div class="pagetitle">
    <h1>Auto Index Queue</h1>
    <nav>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/']">Home</a></li>
        <li class="breadcrumb-item active">Auto Index Queue</li>
      </ol>
    </nav>
  </div>

  <section class="section dashboard">
    <div class="container bg-white overflow-auto container-custom">

      <span class="h5 m-1">
        <span class="badge bg-light text-dark mt-2 mb-2 tooltip-custom">
          <i class="bi bi-clock-history me-1"></i> <span class="tooltiptext">
            The last time we checked this queue <br /> and submitted URLs for indexing was <br /> {{lastSubmission}} hours ago
          </span> <span> Last Submission: {{lastSubmission}} hours ago</span>
        </span>
      </span>

      <span class="h5">
        <span class="badge bg-light text-dark mt-2 mb-2 tooltip-custom">
          <i class="bi bi-clock me-1"></i> <span class="tooltiptext">
            The next time we will check this queue <br /> and submit URLs for indexing is <br /> in {{nextSubmission}} hours.
          </span>
          <span> Next Submission: In {{nextSubmission}} hours</span>
        </span>
      </span>




      <app-spinner *ngIf="showSpinner" loadingText="Fetching indexing statuses from Google..."></app-spinner>
      <table class="table table-hover datatable" id="historyTable" *ngIf="!showSpinner">
        <thead>
          <tr>
            <th scope="col">Url</th>
            <th scope="col">Date Added to Queue</th>
            <th scope="col">Addition Type</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" *ngIf="autoIndexQueue.length==0">
            <td colspan="3">No records found.</td>
          </tr>
          <tr *ngFor="let queue of autoIndexQueue">
            <td>{{queue.url}}</td>
            <td>{{queue.dateAddedToQueue  | date: 'dd/MM/yyyy h:mm a'}}</td>
            <td>
              {{queue.type }}
            </td>
          </tr>

        </tbody>
      </table>
      <div>
        <app-pagination class="float-end" [currentPage]="currentPage" [totalPages]="totalPages" (changePageEvent)="changePage($event)"></app-pagination>
      </div>


    </div>
  </section>
</main>
<app-footer></app-footer>

<a id="btn-back-to-top" class="back-to-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
